/// <amd-module name="Analytics/Shared/Common/Constants" />
export const emsServiceInstanceId = "00000028-0000-8888-8000-000000000000";
export const gridLineColor = "rgba(0,0,0,0.1)";
